export function getTripType(trip = "") {
  const lowerCaseTrip = trip.toLowerCase();
  let tripType = "";

  if (lowerCaseTrip === "roundtrip") {
    tripType = "RT";
  } else if (lowerCaseTrip === "oneway") {
    tripType = "OW";
  } else if (lowerCaseTrip === "multicity") {
    tripType = "MC";
  }

  return tripType;
}
